import React, { Component } from 'react';
import { DialogList, STATE_MANAGER } from 'shared/dialogs/state';
import { ConfirmDialog } from './ConfirmDialog';

interface State {
    dialogs: DialogList;
}

/**
 * Shows 0 or more dialogs on the screen.
 */
export class Dialogs extends Component<unknown, State> {
    public state: State = {
        dialogs: [],
    };

    public componentDidMount() {
        this.componentWillUnmount = STATE_MANAGER.registerInstance(this.handleDialogsChanged);
    }

    public render() {
        return this.state.dialogs.map((props) => (
            <ConfirmDialog
                {...props}
                key={props.modalId}
                onCloseAnimationComplete={this.handleDialogCloseAnimationComplete}
            />
        ));
    }

    private handleDialogsChanged = (dialogs: DialogList | null) => this.setState({ dialogs: dialogs || [] });

    private handleDialogCloseAnimationComplete = (modalId: string) => {
        // Cleanup disposed dialogs
        STATE_MANAGER.instanceState = STATE_MANAGER.instanceState.filter((props) => props.modalId !== modalId);
    };
}
